import { ref } from '@vue/composition-api'
import CustomerApi from '@/api/waiter/Customer'
import { handleApiError } from '@/utils/errorHandler'

export default function useCustomerVisitPattern(vm) {
  const visitPattern = ref(null)
  const loading = ref(false)

  const fetchCustomerVisitPattern = async (customerId, { startDate = null, endDate = null } = {}) => {
    loading.value = true
    try {
      const res = await CustomerApi.getCustomerVisitPattern(customerId, { startDate, endDate })
      visitPattern.value = res.data || null

      return visitPattern.value
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })

      return null
    } finally {
      loading.value = false
    }
  }

  return {
    visitPattern,
    loading,
    fetchCustomerVisitPattern,
  }
}
